import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

interface TextProps {
  color?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'info'
    | 'dark'
    | 'light'
    | 'white'
    | 'title'
    | 'subtitle1'
    | 'subtitle2'
    | 'subtitle3'
    | string;
  component?: 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  sizeType?: 'fs' | 'display';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  weight?:
    | 'bolder'
    | 'bold'
    | 'semibold'
    | 'medium'
    | 'normal'
    | 'light'
    | 'lighter';
  className?: string;
}

const Text = ({
  children,
  color,
  size,
  sizeType = 'fs',
  className,
  component,
  weight,
}: PropsWithChildren<TextProps>) => {
  const classes = classNames(
    {
      [`text-${color}`]: color,
      [`${sizeType}-${size}`]: sizeType && size,
      [`${sizeType == 'fs' ? 'lh' : 'lh-display'}-${size}`]: sizeType && size,
      [`fw-${weight}`]: weight,
    },
    className,
  );

  if (component == 'p') {
    return <p className={classes}>{children}</p>;
  } else if (component == 'h1') {
    return <h1 className={classes}>{children}</h1>;
  } else if (component == 'h2') {
    return <h2 className={classes}>{children}</h2>;
  } else if (component == 'h3') {
    return <h3 className={classes}>{children}</h3>;
  } else if (component == 'h4') {
    return <h4 className={classes}>{children}</h4>;
  } else if (component == 'h5') {
    return <h5 className={classes}>{children}</h5>;
  } else if (component == 'h6') {
    return <h6 className={classes}>{children}</h6>;
  }
  return <span className={classes}>{children}</span>;
};

export default Text;
